import { useEffect } from 'react'
import { View, type ViewStyle } from 'react-native'
import Animated, {
  cancelAnimation,
  Easing,
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withSequence,
  withTiming,
} from 'react-native-reanimated'
import { useCreateStyles } from './styles'

type InputCursorProps = {
  size: number
  style?: ViewStyle
  isVisible: boolean
}

export function InputCursor(props: InputCursorProps) {
  const styles = useCreateStyles()
  const blinkOpacity = useSharedValue(0)
  const cursorStyle = useAnimatedStyle(() => ({
    opacity: blinkOpacity.value,
  }))

  useEffect(() => {
    blinkOpacity.value = 1
    blinkOpacity.value = withRepeat(
      withSequence(
        withTiming(1, { duration: 250, easing: Easing.linear }), // hold visible briefly
        withTiming(0, { duration: 620 }), // fade out
        withTiming(0, { duration: 120 }), // keep invisible briefly
      ),
      -1,
      false,
    )
    return () => {
      cancelAnimation(blinkOpacity)
    }
  }, [])

  if (!props.isVisible) return <View style={[styles.cursorHidden, props.style]} />
  return <Animated.View style={[styles.cursor, cursorStyle, { height: props.size + 2 }, props.style]} />
}
